import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../../core/common';
import Translator from '../../../core/i18n';
import { IAction, IAppState } from '../../../models/action/core';
import { IProcessesProps } from '../../../models/components/activity-copy';
import ActivityMultiple from '../activity-multiple/main';
import GradeChart from '../grade-chart/main';
import AddClass from '../add-class/main';
import ManageClass from '../manage-class/main';
import { UserType } from '../../../models/enums/userType';
import ActivityCopy from '../activity-copy/main';
import * as Actions from '../../../store/actions/coursePage'
import CPollingQr from '../polling-qr/main';
import NotFound from '../../not-found/not-found';
import * as ActionsQr from '../../../store/actions/qrPolling';
import { SecurityContextType, SecurityPermissionType } from '../../../core/SecurityContext';
import CourseLearningOutcomes from '../learning-outcomes/main';
import MadlenIntegration from '../madlen-integration/main';

const T = Translator.create();
let _common: Common;
const _logger = Log.create('Course Processes');

interface IProcessesState {
    selectedCard: string | null;
    selectedTab: string | null;
    openCard: string | null;
    activeCard: string | null;
}
interface CardInfo {
    name: string;
    title: string;
    component: JSX.Element;
    icon: string;
    description: string;
    iconBg: string;
    iconColor: string;
}
class CProcesses extends Component<IProcessesProps, IProcessesState> {
    cards: CardInfo[];
    constructor(props: any) {
        super(props);
        _common = new Common();
        this.state = {
            selectedCard: null,
            openCard: null,
            activeCard: null,
            selectedTab: null
        };
        this.cards = [
            {
                name: 'addClass',
                title: T.t('r_course_add_class'),
                component: <AddClass courseId={this.props.courseId} classId={this.props.classId ? this.props.classId : ""} />,
                icon: 'school',
                description: T.t('r_course_add_class_info'),
                iconBg: '#e7e4ee',
                iconColor: '#6e4fb6'
            },
            {
                name: 'manageClass',
                title: T.t('r_course_manage_class'),
                component: <ManageClass classId={this.props.classId} />,
                icon: 'star',
                description: T.t('r_course_manage_class_info'),
                iconBg: '#fff5e6',
                iconColor: '#e69319'
            },
            {
                name: 'activityCopy',
                title: T.t('r_activity_copy'),
                component: <ActivityCopy courseId={this.props.courseId} classId={this.props.classId!} copyResultData={null} />,
                icon: 'book',
                description: T.t('r_activity_copy_explain'),
                iconBg: '#0099ff',
                iconColor: '#eeeeee'
            },
            {
                name: 'activityMultiple',
                title: T.t('r_virtual_class_multiple'),
                component: <ActivityMultiple courseId={this.props.courseId} classId={this.props.classId!} copyResultData={null} dateFormat={''} formik={this.props} />,
                icon: 'content_copy',
                description: T.t('r_virtual_class_multiple_explain'),
                iconBg: '#b28639',
                iconColor: '#eeeeee'
            }
            ,
            {
                name: 'gradeChart',
                title: T.t('r_activity_creating_a_grade_chart'),
                component: <GradeChart classId={this.props.classId} />,
                icon: 'view_list',
                description: T.t('r_activity_creating_a_grade_chart_info'),
                iconBg: '#fcccc2',
                iconColor: '#8a0f0f'
            },
            {
                name: 'qrCode',
                title: T.t('r_polling_by_qr'),
                component: <CPollingQr />,
                icon: 'qr_code_2',
                description: T.t('r_polling_by_qr_explain'),
                iconBg: '#39b27b',
                iconColor: '#eeeeee'
            },
            {
                name: 'learningOutcomes',
                title: T.t('r_course_learning_outcomes'),
                component: <CourseLearningOutcomes />,
                icon: 'sticky_note_2',
                description: T.t('r_course_learning_outcomes_description'),
                iconBg: '#f2c879',
                iconColor: '#eeeeee'
            },
            {
                name: 'madlenIntegration',
                title: T.t('r_madlen_content_sync'),
                component: <MadlenIntegration courseId={this.props.courseId ?? ""} classId={this.props.classId ?? ''} />,
                icon: 'published_with_changes',
                description: T.t('r_madlen_content_sync'),
                iconBg: '#622AFD',
                iconColor: '#eeeeee'
            },
        ];

    }

    handleItemClick = (itemName: string) => {
        const selectedCard = this.cards.find((card) => card.name === itemName) || null;

        this.setState(
            {
                selectedTab: itemName,
                selectedCard: selectedCard ? selectedCard.name : null,
                openCard: selectedCard ? selectedCard.name : null,
                activeCard: selectedCard ? selectedCard.name : null,
            },
            () => {
                // Aktif kartı localStorage'a kaydet
                localStorage.setItem('activeCard', itemName);
            }
        );
    };


    componentDidMount() {
        const savedActiveCard = localStorage.getItem('activeCard');

        // Eğer localStorage'da geçerli bir kart varsa, onu yükle
        if (savedActiveCard && this.cards.some((card) => card.name === savedActiveCard)) {
            this.setState({ activeCard: savedActiveCard, selectedCard: savedActiveCard, openCard: savedActiveCard });
        } else {
            // Eğer localStorage'da bilgi yoksa hiçbir kart aktif değil
            this.setState({ activeCard: null, selectedCard: null, openCard: null });
        }
        this.props.dispatch(ActionsQr.GetClassess(this.props.courseId ?? ''));

    }


    renderCard(card: CardInfo) {
        const { selectedCard, activeCard } = this.state;
        const isActive = activeCard === card.name || selectedCard === card.name;

        if ((this.props.classes?.classes?.length <= 0 && this.props.qrClassess.length <= 0) && card.name === "qrCode")
            return null;
        if (selectedCard === card.name) {
            return (
                <div key={card.name} className={isActive ? `tab-panel active-card1 ${card.name}` : 'hidden-card'} style={{ minHeight: 200 }}>
                    {card.component}
                </div>
            );
        }
        return null;
    }

    componentWillUnmount = () => {
        this.props.dispatch(Actions.getCourseContentMenu(this.props.classId, this.props.courseId ?? '', "", true, "getCourseContentMenu", "get"))

    }

    public render() {
        const { activeCard } = this.state;
        const isDataLoaded = this.props.termWeeks && this.props.termWeeks.length > 0; // Örnek durum kontrolü
        return (
            <div className="student-course" style={{ minHeight: '80vh' }}>
                <div className="container-fluid px-4 py-2">
                    <div className="row">
                        <div className="col-3">
                            <div className="tab-header">
                                {this.cards.map(card => {
                                    if (
                                        (card.name === 'addClass' || card.name === 'manageClass') &&
                                        this.props.userType !== UserType.Admin
                                    ) {
                                        return null;
                                    }

                                    if (
                                        card.name === 'activityMultiple' &&
                                        (!this.props.termWeeks || this.props.termWeeks.filter((item) => item.termId !== null).length === 0)
                                    ) {
                                        return null;
                                    }

                                    if (
                                        card.name === 'qrCode' &&
                                        (this.props.classes?.classes?.length <= 0 && this.props.qrClassess.length <= 0)
                                    ) {
                                        return null;
                                    }

                                    if (card.name === 'gradeChart' && !Common.HasPermission(SecurityContextType.Activity, SecurityPermissionType.Activity_GradeBook_Manage, this.props.courseId!)) {
                                        return null;
                                    }

                                    if(card.name === 'madlenIntegration' && !this.props.displayContentSyncPage) {
                                        return null;
                                    }

                                    return (
                                        <button
                                            key={card.name}
                                            className={`tab-button processes-card ${activeCard === card.name ? 'active' : ''}`}
                                            onClick={() => this.handleItemClick(card.name)}
                                        >
                                            <div className="process-row-image" style={{ backgroundColor: card.iconBg }}>
                                                <i className="material-icons process-row-icon" style={{ color: card.iconColor }}>
                                                    {card.icon}
                                                </i>
                                            </div>
                                            <div className="d-flex align-items-start flex-column" style={{ gap: '.25em' }}>
                                                <span className="title">{card.title}</span>
                                                <span className="description">{card.description}</span>
                                            </div>
                                        </button>
                                    );
                                })}
                            </div>

                        </div>
                        <div className="col-9">
                            <div className="tab-content">
                                {activeCard
                                    ? this.cards.map((card) => this.renderCard(card)) // Aktif bir kart varsa render et
                                    : (
                                        <NotFound type="emptySelect" message={T.t('r_which_process')} /> // Aktif kart yoksa NotFound göster
                                    )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IProcessesProps): IProcessesProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IProcessesProps = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        termWeeks: state.coursePage.courseContentTermWeeks,
        copyResultData: state.activityCopy.copyResultData,
        courseId: state.coursePage.coursePageActivityId,
        classes: state.coursePage.classes,
        qrClassess: state.qrPolling.Classess,
        displayContentSyncPage: state.login.login.displayContentSyncPage

    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.activityCopy.copyResultData === prev.activityCopy.copyResultData &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.classes === prev.coursePage.classes &&
        next.qrPolling.Classess === prev.qrPolling.Classess
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const Processes = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CProcesses);

export default Processes;
